import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import ModalConfirm from "../../common/modal-confirm";
import ModalAlert from "../../common/modal-alert";
import Pagination from "../../../components/Common/pagination";
import Moment from "react-moment";

import "moment-timezone";
import { format, parseISO } from 'date-fns';
import { zonedTimeToUtc, utcToZonedTime, format as formatTZ } from 'date-fns-tz';

// Set the timezone for every instance.
Moment.globalTimezone = 'America/Sao_Paulo';
const zonaHoraria = 'America/Sao_Paulo';

class Permission extends Component {
  state = {
    load: false,
    integrations: {},
    page: 1,
    paginas: 0,
    msgErro: null,
    modalTitle: null,
    modalMsg: null,
    modalAction: null,
    errors: {},
    idDelete: null,
    alterIntegration: false,
    idAlter: null,
    curIntegration:false,
    listPresence: {},
    companies: {},
    instructors: {},
    uploadingFile: false,
    selectedIntegrationId: null
  };

  componentDidMount() {
    this.searchIntegrations();
    this.searchInstructor();
  }

  // Helper function to count active schedules (matching backend validation logic)
  // Counts schedules where showedUp is null (pending) OR true (confirmed)
  // Only excludes no-shows (showedUp: false) as they free up spots
  countActiveSchedules = (schedules) => {
    return schedules.filter(schedule => {
      return schedule.showedUp !== false;  // Count pending (null) and confirmed (true), exclude no-shows (false)
    }).length;
  };

  searchIntegrations = async e => {
    let page = e ? e.target.id : 1;

    this.setState({ load: true, page });
    const response = await api.get(
      `/integrations?order_by=id&order_direction=DESC&page=${page}`
    );
      
    this.setState({
      integrations: response.data.rows,
      load: false,
      paginas: Math.ceil(response.data.count / 10)
    });
  };

  insertIntegration = () => {
    document.getElementById("data_integracao").value = "";
    document.getElementById("hora_integracao").value = "";
    document.getElementById("numero_vagas").value = "";
    document.getElementById("instrutor").value = "";
    document.getElementById("instrutor2").value = "";
    document.getElementById("instrutor3").value = "";
    document.getElementById("obs").value = "";
    this.setState({
      msgErro: null,
      errors: {},
      alterIntegration: false,
      idAlter: null
    });
  };

  createIntegration = async () => {
    let date = document.getElementById("data_integracao").value;
    console.log("data: " + date);
    let hora_integracao =
      document.getElementById("hora_integracao").value + ":00";
    let vacancies = document.getElementById("numero_vagas").value;
    let instructor = document.getElementById("instrutor").value;
    let instructor2 = document.getElementById("instrutor2").value;
    let instructor3 = document.getElementById("instrutor3").value;
    let instructors = [instructor, instructor2, instructor3];

    let note = document.getElementById("obs").value;
    this.setState({ load: true });
    date = date + " " + hora_integracao;
    console.log("data com hora: " + date);

    try {
      let result = await api.post(`/integrations`, {
        date,
        vacancies,
        instructor,
        note,
        instructors
      });

      if (result.data.msg) {
        this.setState({ load: false });
        this.searchIntegrations();

        document.getElementById("closeModalCreate").click();
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: result.data.msg,
          classText: "text-success",
          errors: {}
        });

        document.getElementById("data_integracao").value = "";
        document.getElementById("hora_integracao").value = "";
        document.getElementById("numero_vagas").value = "";
        document.getElementById("instrutor").value = "";
        document.getElementById("instrutor2").value = "";
        document.getElementById("instrutor3").value = "";
        document.getElementById("obs").value = "";
      }
    } catch (error) {
      let errors = error.response.data.errors;
      this.setState({
        errors,
        msgErro: "Não foi possível cadastrar a integração! Tente novamente.",
        load: false
      });
    }
  };

  checkInstrutor(id){
    if(!this.state.curIntegration) return false;
    console.log(this.state.curIntegration);
    let dados = this.state.curIntegration.Users.filter(item => {
      return item.id == id;
    });
    if (dados.length) {
      return true;
    } else {
      return false;
    }
  }

  alterIntegrationFunc = e => {

    let dados = this.state.integrations.filter(item => item.id == e.target.id);
    
    this.setState({curIntegration:dados[0]})
    if (dados.length) {
     
      const dateComplete = new Date(dados[0].date);      
      const dateFormatted = formatTZ(dateComplete, 'yyyy-MM-dd', { zonaHoraria });
      const timeFormatted = formatTZ(dateComplete, 'HH:mm:ss', { zonaHoraria });
     
      let dataCompleta = dados[0].date.split("T");
      let data = dataCompleta[0].split("-");
      data = data[2] + "/" + data[1] + "/" + data[0];

      let hora = dataCompleta[1].split(":");
      hora = hora[0] + ":" + hora[1];
    
     
 

      var inst1 = null;
      var inst2 = null;
      var inst3 = null;
      if (this.state.instructors.length) {
        inst1 = this.state.instructors.filter(item => item.SectorId == 5);
        inst2 = this.state.instructors.filter(item => item.SectorId == 21);
        inst3 = this.state.instructors.filter(item => item.SectorId == 6);
      }

      var instru1 = null;
      var instru2 = null;
      var instru3 = null;
      instru1 = inst1.map(i => {
        return dados[0].Users.filter(item => item.id == i.id)[0];
      }).filter(it => it !== undefined);
      instru2 = inst2.map(i => {
        return dados[0].Users.filter(item => item.id == i.id)[0];
      }).filter(it => it !== undefined);
      instru3 = inst3.map(i => {
        return dados[0].Users.filter(item => item.id == i.id)[0];
      }).filter(it => it !== undefined);

      console.log('inst2 & inst3:');
      console.log(JSON.stringify(inst2));
      console.log(this.state.instructors);
      // console.log(inst2);
      // console.log(inst3);

      document.getElementById("btnCreateIntegration").click();
      document.getElementById("data_integracao").value = dateFormatted;
      document.getElementById("hora_integracao").value = timeFormatted;
      document.getElementById("numero_vagas").value = dados[0].vacancies;
      document.getElementById("instrutor").value = (instru1 !== null && instru1.length > 0)
        ? instru1[0].id
        : null;
      document.getElementById("instrutor2").value = (instru2 !== null && instru2.length > 0)
        ? instru2[0].id
        : null;
      document.getElementById("instrutor3").value = (instru3 !== null && instru3.length > 0)
        ? instru3[0].id
        : null;
      document.getElementById("obs").value = dados[0].note;

      this.setState({ alterIntegration: true, idAlter: e.target.id });
    }
  };

  ActionAlterIntegration = async () => {
    let date = document.getElementById("data_integracao").value;
    console.log("data: " + date)
    let hora_integracao = document.getElementById("hora_integracao").value;
    
    if (hora_integracao && !hora_integracao.includes(':00') && hora_integracao.split(':').length === 2) {
      hora_integracao = hora_integracao + ':00';
    }
    
    let vacancies = document.getElementById("numero_vagas").value;
    let instructor = document.getElementById("instrutor").value;
    let instructor2 = document.getElementById("instrutor2").value;
    let instructor3 = document.getElementById("instrutor3").value;
    let instructors = Array(instructor, instructor2, instructor3);

    let note = document.getElementById("obs").value;
    this.setState({ load: true });
    date = date + " " + hora_integracao;
    console.log("data com hora: " + date);

    try {
      const result = await api.put(`/integrations/${this.state.idAlter}`, {
        date,
        vacancies,
        instructor,
        note,
        instructors
      });

      // Refetch the integrations list to show updated data
      await this.searchIntegrations();

      this.setState({ load: false });
      document.getElementById("closeModalCreate").click();
      document.getElementById("modal-alert").click();
      this.setState({
        msgAlert: result.data.msg,
        classText: "text-success",
        errors: {},
        idAlter: null
      });

      // Clear form fields
      document.getElementById("data_integracao").value = "";
      document.getElementById("hora_integracao").value = "";
      document.getElementById("numero_vagas").value = "";
      document.getElementById("instrutor").value = "";
      document.getElementById("obs").value = "";
    } catch (error) {
      let errors = error.response.data.errors;
      this.setState({
        errors,
        msgErro: "Não foi possível alterar a integração! Tente novamente.",
        load: false
      });
    }
  };

  verifyValidation = id => {
    if (this.state.errors && this.state.errors.length) {
      let dados = this.state.errors.filter(item => {
        return item.param == id;
      });
      if (dados.length) {
        return dados[0].msg;
      } else {
        return false;
      }
    }
  };

  deleteIntegration = e => {
    document.getElementById("modal-confirm").click();
    this.setState({
      idDelete: e.target.id,
      msgErro: null,
      msgAlert: null,
      modalTitle: "Atenção!",
      modalMsg: "Tem certeza que excluir a integração?",
      modalAction: "delete"
    });
  };

  confirmDeleteIntegration = async () => {
    this.setState({ load: true, msgErro: null, msgAlert: null });
    await api
      .delete(`/integrations/${this.state.idDelete}`)
      .then(result => {
        this.setState({ load: false });
        this.searchIntegrations();
        document.getElementById("close-modal-confirm").click();
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: result.data.msg,
          classText: "text-success",
          idDelete: null,
          idClose: null
        });
      })
      .catch(error => {
        this.setState({ msgErro: error.response.data.msg, load: false });
      });
  };

  confirmModalAction = async () => {
    if (this.state.modalAction === "close") {
      //Fecha integração
      try {
        let response = await api.patch(
          `/integrations/${this.state.idClose}/close`
        );
        this.searchIntegrations();
        document.getElementById("close-modal-confirm").click();
        document.getElementById("modal-alert").click();
        this.setState({
          load: false,
          msgAlert: response.data.msg,
          classText: "text-success",
          msgSuccess: null,
          idDelete: null,
          idClose: null
        });
      } catch (error) {
        document.getElementById("modal-alert").click();
        this.setState({
          msgAlert: "Erro. Tente novamente mais tarde!",
          classText: "text-danger",
          errors: {}
        });
      }
    } else if (this.state.modalAction === "delete") {
      //Deleta integração
      this.confirmDeleteIntegration();
    }
  };

  listIntegration = async (e, idInt) => {
    this.setState({ load: true, msgSuccess: null });
    let id = null;
    if (e) {
      this.setState({ idIntegration: e.target.id });
      id = e.target.id;
    } else {
      id = idInt;
    }

    const response = await api.get(
      `/integration-schedules?IntegrationId=${id}`
    );
    console.log(response.data.rows);
    this.setState({ listPresence: response.data.rows, load: false });
  };

  setPresenceIntegration = async e => {
    let idUser = e.target.name;
    if (e && e.target.id) {
      await api
        .patch(`/integration-schedules/${e.target.id}`, { showedUp: true })
        .then(async result => {
          this.listIntegration(null, this.state.idIntegration);

          await api.patch(`/employees/${idUser}`, { EmployeeStatusId: 5 });

          this.setState({
            msgSuccess: result.data.msg,
            msgErro: null,
            load: false
          });

          setTimeout(() => {
            this.setState({ msgAlert: null, classText: null });
          }, 2500);
        });
    }
  };

  setFaultIntegration = async e => {
    if (e && e.target.id) {
      await api
        .patch(`/integration-schedules/${e.target.id}`, { showedUp: false })
        .then(async result => {
          this.listIntegration(null, this.state.idIntegration);


          this.setState({
            msgSuccess: result.data.msg,
            msgErro: null,
            load: false
          });

          setTimeout(() => {
            this.setState({ msgAlert: null, classText: null });
          }, 2500);

        });
    }
  };

  searchInstructor = async e => {
    this.setState({ load: true });
    const response = await api.get(`/instructors`);
    this.setState({
      instructors: response.data,
      load: false,
      paginas: Math.ceil(response.data.count / 10)
    });
  };

  fecharIntegration = async e => {
    this.setState({
      modalTitle: "Atenção!",
      modalMsg: "Tem certeza que deseja fechar a integração?",
      modalAction: "close",
      idClose: e.target.id
    });
    document.getElementById("modal-confirm").click();
  };

  downloadPresenceList = async (integrationId) => {
    try {
      this.setState({ load: true });
      
      const response = await api.get(`/integrations/${integrationId}/presence-list`, {
        responseType: 'blob' // Important for handling binary data
      });
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Set the filename for download
      link.setAttribute('download', `lista-presenca-integracao-${integrationId}.pdf`);
      
      // Append to html link element page
      document.body.appendChild(link);
      
      // Start download
      link.click();
      
      // Clean up and remove the link
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      this.setState({ load: false });
    } catch (error) {
      console.error('Error downloading presence list:', error);
      this.setState({ 
        load: false,
        msgAlert: "Erro ao baixar a lista de presença. Tente novamente.",
        classText: "text-danger"
      });
      document.getElementById("modal-alert").click();
    }
  };

  uploadSignedPresenceList = async (e) => {
    const file = e.target.files[0];
    const integrationId = e.target.getAttribute('data-integration-id');
    
    if (!file) return;

    // Validate file type
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      this.setState({
        msgAlert: "Apenas arquivos PDF, JPG, JPEG e PNG são permitidos.",
        classText: "text-danger"
      });
      document.getElementById("modal-alert").click();
      return;
    }

    this.setState({ uploadingFile: true });

    try {
      const formData = new FormData();
      formData.append('attachment', file);

      console.log('Uploading file:', file.name, 'to integration:', integrationId);

      const response = await api.post(`/integrations/${integrationId}/signed-presence-list`, formData);

      console.log('Upload response:', response);

      this.setState({
        uploadingFile: false,
        msgAlert: response.data.msg || "Documento enviado com sucesso.",
        classText: "text-success"
      });
      document.getElementById("modal-alert").click();
      
      // Refresh the integrations list to show the uploaded file
      this.searchIntegrations();

    } catch (error) {
      console.error('Upload error:', error);
      console.error('Error response:', error.response);
      
      this.setState({
        uploadingFile: false,
        msgAlert: (error.response && error.response.data && error.response.data.msg) || "Erro ao enviar arquivo. Tente novamente.",
        classText: "text-danger"
      });
      document.getElementById("modal-alert").click();
    }
  };

  downloadSignedPresenceList = async (integrationId) => {
    try {
      this.setState({ load: true });
      
      const response = await api.get(`/integrations/${integrationId}/signed-presence-list`, {
        responseType: 'blob'
      });
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Extract filename from response headers if available, otherwise use default
      const contentDisposition = response.headers['content-disposition'];
      let filename = `lista-presenca-assinada-${integrationId}.pdf`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      this.setState({ load: false });
    } catch (error) {
      console.error('Error downloading signed presence list:', error);
      this.setState({ 
        load: false,
        msgAlert: (error.response && error.response.data && error.response.data.msg) || "Erro ao baixar o documento. Tente novamente.",
        classText: "text-danger"
      });
      document.getElementById("modal-alert").click();
    }
  };

  closeAllModals = () => {
    // get modals
    const modals = document.getElementsByClassName('modal');
    document.querySelector('body').classList.remove('modal-open');

    // on every modal change state like in hidden modal
    for(let i=0; i<modals.length; i++) {
      modals[i].classList.remove('show');
      modals[i].setAttribute('aria-hidden', 'true');
      modals[i].setAttribute('style', 'display: none');
    }

     // get modal backdrops
     const modalsBackdrops = document.getElementsByClassName('modal-backdrop');

     // remove every modal backdrop
     for(let i=0; i<modalsBackdrops.length; i++) {
       document.body.removeChild(modalsBackdrops[i]);
     }
  };

  render() {
    return (
      <Fragment>
        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">
              Configurações de Integrações
              {this.state.load ? <i className="fa fa-spin fa-spinner" /> : null}
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="alert alert-info">
              Este módulo é para cadastrar as opções de integrações que as
              empresas poderão selecionar!
            </div>

            <div className="card">
              <div className="p-20 text-right">
                <div
                  className="col-md-2 btn btn-rounded btn-primary"
                  id="btnCreateIntegration"
                  data-toggle="modal"
                  data-target=".modal-alter-integration"
                  onClick={this.insertIntegration}
                >
                  Cadastrar
                </div>
              </div>

              <table className="table table-bodered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Data</th>
                    <th>Vagas</th>
                    <th className="text-center">Funcionários</th>
                    <th />
                    <th />
                    <th />
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {this.state.integrations.length
                    ? this.state.integrations.map(item => {
                        return (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>
                         
                              <Moment format="DD/MM/YYYY HH:mm" tz="America/Sao_Paulo">
                                {item.date}
                              </Moment>
                            </td>
                            <td>{item.vacancies}</td>
                            <td className="text-center">
                              <span className="label label-info">
                                {this.countActiveSchedules(item.IntegrationSchedules)}
                              </span>
                            </td>
                            <td>
                              {!item.closed ? (
                                <button
                                  id={item.id}
                                  onClick={this.fecharIntegration}
                                  className="btn btn-sm btn-rounded btn-outline-danger"
                                >
                                  Fechar Integração
                                </button>
                              ) : (
                                <span className="label label-danger">
                                  Integração Fechada
                                </span>
                              )}
                            </td>
                            <td>
                              <button
                                data-toggle="modal"
                                id={item.id}
                                data-target=".modal-list-integration"
                                className="btn btn-sm btn-rounded btn-outline-info"
                                onClick={this.listIntegration}
                              >
                                Lista de presença
                              </button>
                              <button
                                onClick={() => this.downloadPresenceList(item.id)}
                                className="btn btn-sm btn-rounded btn-outline-info m-l-10"
                              >
                                <i className="fa fa-download" />
                              </button>
                              
                              {item.closed && (
                                <div className="m-t-10">
                                  {item.IntegrationAttachments && item.IntegrationAttachments.length > 0 ? (
                                    <button
                                      onClick={() => this.downloadSignedPresenceList(item.id)}
                                      className="btn btn-sm btn-rounded btn-outline-success"
                                      title="Baixar lista de presença assinada"
                                    >
                                      <i className="fa fa-download" /> Lista Assinada
                                    </button>
                                  ) : null}
                                  
                                  <div className="file-upload-wrapper" style={{ display: 'inline-block', marginLeft: '10px' }}>
                                    <input
                                      type="file"
                                      id={`upload-${item.id}`}
                                      data-integration-id={item.id}
                                      onChange={this.uploadSignedPresenceList}
                                      accept=".pdf,.jpg,.jpeg,.png"
                                      style={{ display: 'none' }}
                                    />
                                    <button
                                      onClick={() => document.getElementById(`upload-${item.id}`).click()}
                                      className="btn btn-sm btn-rounded btn-outline-warning"
                                      disabled={this.state.uploadingFile}
                                      title={item.IntegrationAttachments && item.IntegrationAttachments.length > 0 
                                        ? "Substituir lista de presença assinada" 
                                        : "Enviar lista de presença assinada"}
                                    >
                                      {this.state.uploadingFile ? (
                                        <i className="fa fa-spinner fa-spin" />
                                      ) : (
                                        <i className="fa fa-upload" />
                                      )} 
                                      {item.IntegrationAttachments && item.IntegrationAttachments.length > 0 
                                        ? " Substituir" 
                                        : " Enviar lista assinada"}
                                    </button>
                                  </div>
                                </div>
                              )}
                            </td>
                            <td className="td-button">
                              {!item.closed ? (
                                <button
                                  type="button"
                                  id={item.id}
                                  onClick={this.alterIntegrationFunc}
                                  data-toggle="modal"
                                  data-target=".modal-alter-integration"
                                  className="btn btn-sm btn-outline-success btn-circle"
                                >
                                  <i id={item.id} className="fa fa-edit" />
                                </button>
                              ) : null}
                            </td>
                            <td className="td-button">
                              {!item.closed ? (
                                <button
                                  type="button"
                                  id={item.id}
                                  onClick={this.deleteIntegration}
                                  className="btn btn-sm btn-outline-danger btn-circle"
                                >
                                  <i id={item.id} className="fa fa-times" />
                                </button>
                              ) : null}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>

              {this.state.paginas > 0 ?
                <Pagination
                  function={this.searchIntegrations}
                  paginas={this.state.paginas}
                  curPage={this.state.page}
                />
              : null }
            </div>
          </div>
        </div>

        <ModalConfirm
          title={this.state.modalTitle}
          msg={this.state.modalMsg}
          function={this.confirmModalAction}
          msgError={this.state.msgErro}
        />
        <ModalAlert
          title="Informação"
          msg={this.state.msgAlert}
          function=""
          classText={this.state.classText}
        />

        <div
          className="modal fade modal-alter-integration"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  {!this.state.alterIntegration ? "Cadastrar " : "Alterar "}
                  Integração
                  {this.state.load ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : null}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-md-4">
                      <span>
                        Data da integração <i className="text-danger">*</i>
                      </span>
                      <div className="input-group">
                        <input
                          type="date"
                          className="form-control"
                          id="data_integracao"
                        />
                      </div>
                      <i className="message-error">
                        {this.verifyValidation("date")}
                      </i>
                    </div>
                    <div className="col-md-4">
                      <span>
                        Hora da integração <i className="text-danger">*</i>
                      </span>
                      <div
                        className="input-group clockpicker "
                        data-placement="bottom"
                        data-align="top"
                        data-autoclose="true"
                      >
                        <input
                          type="time"
                          id="hora_integracao"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <span>
                        Número de Vagas <i className="text-danger">*</i>
                      </span>
                      <input
                        type="number"
                        id="numero_vagas"
                        className="form-control"
                      />
                      <i className="message-error">
                        {this.verifyValidation("vacancies")}
                      </i>
                    </div>

                    <div className="col-md-12">
                      <br />
                      <h2>Instrutores</h2>
                    </div>

                    <div className="col-md-4">
                      <span>
                        Segurança do Trabalho<i className="text-danger">*</i>
                      </span>
                      {/* <input type="text" id="instrutor" className="form-control"></input> */}

                      <select className="form-control" id="instrutor">
                        <option />
                        {this.state.instructors.length
                          ? this.state.instructors.map(item => {
                              return item.SectorId == 5 ? (
                                <option key={item.id} value={item.id} selected={this.checkInstrutor(item.id)}>
                                  {item.name}
                                </option>
                              ) : null;
                            })
                          : null}
                      </select>
                      <i className="message-error">
                        {this.verifyValidation("instructor")}
                      </i>
                    </div>
                    <div className="col-md-4">
                      <span>
                        Meio Ambiente<i className="text-danger">*</i>
                      </span>
                      <select className="form-control" id="instrutor2">
                        <option />
                        {this.state.instructors.length
                          ? this.state.instructors.map(item => {
                              return item.SectorId == 21 ? (
                                <option key={item.id} value={item.id} selected={this.checkInstrutor(item.id)} >
                                  {item.name}
                                </option>
                              ) : null;
                            })
                          : null}
                      </select>
                      <i className="message-error">
                        {this.verifyValidation("instructor")}
                      </i>
                    </div>
                    <div className="col-md-4">
                      <span>
                        Patrimonial <i className="text-danger">*</i>
                      </span>
                      <select className="form-control" id="instrutor3">
                        <option />
                        {this.state.instructors.length
                          ? this.state.instructors.map(item => {
                              return item.SectorId == 6 ? (
                                <option key={item.id} value={item.id} selected={this.checkInstrutor(item.id)}>
                                  {item.name}
                                </option>
                              ) : null;
                            })
                          : null}
                      </select>
                      <i className="message-error">
                        {this.verifyValidation("instructor")}
                      </i>
                    </div>

                    <div className="col-md-12">
                      <br />
                      <span>
                        Observação <i className="text-danger">*</i>
                      </span>
                      <textarea id="obs" className="form-control" rows="8" />
                      <i className="message-error">
                        {this.verifyValidation("note")}
                      </i>
                    </div>

                    {this.state.msgErro ? (
                      <div className="col-md-12">
                        <div className="alert alert-danger">
                          {this.state.msgErro}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                {this.state.load ? (
                  <i className="fa fa-spin fa-spinner" />
                ) : null}

                {!this.state.alterIntegration ? (
                  <button
                    className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                    onClick={this.createIntegration}
                  >
                    Cadastrar
                  </button>
                ) : (
                  <button
                    className="col-md-2 btn waves-effect waves-light btn-rounded btn-success"
                    onClick={this.ActionAlterIntegration}
                  >
                    Alterar
                  </button>
                )}

                <button
                  type="button"
                  id="closeModalCreate"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade modal-list-integration"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl" style={{maxWidth: '95%'}}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Lista de presença na integração
                  {this.state.load ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : null}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-md-12">
                      {this.state.msgSuccess ? (
                        <div className="alert alert-success">
                          {this.state.msgSuccess}
                        </div>
                      ) : null}

                      {this.state.msgErro ? (
                        <div className="alert alert-danger">
                          {this.state.msgErro}
                        </div>
                      ) : null}

                      <div style={{overflowX: 'auto'}}>
                      <table className="table table-bordered table-striped" style={{fontSize: '0.9rem'}}>
                        <thead style={{backgroundColor: '#f8f9fa'}}>
                          <tr>
                            <th style={{minWidth: '150px'}}>Funcionário</th>
                            <th style={{minWidth: '100px', textAlign: 'center'}}>Data Nascimento</th>
                            <th style={{minWidth: '120px'}}>CPF</th>
                            <th style={{minWidth: '150px'}}>Função</th>
                            <th style={{minWidth: '120px'}}>Setor</th>
                            <th style={{minWidth: '200px'}}>Empresa</th>
                            <th style={{minWidth: '120px', textAlign: 'center'}}>Data integração</th>
                            <th style={{minWidth: '200px', textAlign: 'center'}}>Presença</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listPresence.length
                            ? this.state.listPresence.map(item => {
                                return (
                                  <tr key={item.id}>
                                    <td style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>{item.Employee.name}</td>
                                    <td style={{textAlign: 'center'}}>
                                      {item.Employee.birthDate ? (
                                        <Moment format="DD/MM/YYYY" tz="America/Sao_Paulo">
                                          {item.Employee.birthDate}
                                        </Moment>
                                      ) : '---'}
                                    </td>
                                    <td>{item.Employee.cpf || '---'}</td>
                                    <td style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>{item.Employee.Function ? item.Employee.Function.description : '---'}</td>
                                    <td style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>{item.Employee.Sector ? item.Employee.Sector.name : '---'}</td>
                                    <td style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>{ (item.Employee.Company) ? item.Employee.Company.socialName : '---'}</td>
                                    <td style={{textAlign: 'center'}}>
                                    <Moment format="DD/MM/YYYY HH:mm" tz="America/Sao_Paulo">
                                        {item.Integration.date}
                                      </Moment>
                                    </td>
                                    <td style={{textAlign: 'center'}}>
                                      {item.showedUp == null ? (
                                        <div>
                                          <button
                                            type="button"
                                            name={item.Employee.id}
                                            id={item.id}
                                            onClick={this.setPresenceIntegration}
                                            className="btn btn-rounded btn-outline-info"
                                          >
                                            <i
                                              id={item.id}
                                              className="fa fa-check"
                                            />{" "}
                                            Confirmar Presença
                                          </button>
                                          <button
                                            type="button"
                                            name={item.Employee.id}
                                            id={item.id}
                                            onClick={this.setFaultIntegration}
                                            className="btn btn-rounded btn-danger"
                                          >
                                            <i
                                              id={item.id}
                                              className="fa fa-close"
                                            />{" "}
                                            Confirmar Falta
                                            </button>
                                          </div>
                                      ) : null}

                                      {item.showedUp == false ? (
                                        <span
                                            id={item.id}
                                            className="text-danger"
                                          >
                                            <i
                                              id={item.id}
                                              className="fa fa-check"
                                            />{" "}
                                            Não compareceu
                                        </span>
                                      ) : null }

                                      {item.showedUp == true ? (
                                          <span
                                            id={item.id}
                                            className="text-success"
                                          >
                                            <i
                                              id={item.id}
                                              className="fa fa-check"
                                            />{" "}
                                            Confirmado
                                          </span>
                                      ) : null}

                                    </td>
                                  </tr>
                                );
                              })
                            : null}
                        </tbody>
                      </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                {this.state.load ? (
                  <i className="fa fa-spin fa-spinner" />
                ) : null}
                <button
                  type="button"
                  id="closeModalIntegrations"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Permission;
